






































































import Vue from "vue";
import router from "@/router/";
const PouchDB = require("pouchdb").default;
export default Vue.extend({
  data() {
    return {
      isClosed: false
    };
  },
  methods: {
    close() {
      this.isClosed = true;
    },
  },
  computed: {}
});
